function shapeRatioInit() {
	const theSvg = document.querySelectorAll(".dynamic-aspect-ratio");

	if (theSvg.length > 0) {
		const firstInit = actualResizeHandler();
		window.addEventListener("resize", resizeThrottler, false);

		var resizeTimeout;
		function resizeThrottler() {
			if (!resizeTimeout) {
				resizeTimeout = setTimeout(function() {
					resizeTimeout = null;
					actualResizeHandler();
				}, 66);
			}
		}

		function actualResizeHandler() {
			theSvg.forEach(item => {
				item.setAttribute(
					"preserveAspectRatio",
					window.innerWidth > 1439 ? "none" : "xMidYMid slice"
				);
			});
		}
	}
}
